export const softSetField = (form, field, value, force) => {
    if (value || force) {
        const empty = form.getValues(field) ? false : true
        if (empty || force) {
            form.setValue(field, value)
        }
    }
}
